import React from 'react';
import { Route, Switch, matchPath } from 'react-router-dom';
import ListSearch from 'pages/ListSearch';
import MapSearch from 'pages/MapSearch';
import Property from 'pages/Property';
import Checkout from 'pages/Checkout';
import FAQs from 'pages/FAQs';
import BookingConfirmation from 'pages/BookingConfirmation';
import Destination from 'pages/Destination';
import { ContactUs, Enquiry } from 'pages/ContactUs';
import FourOhFourPage from 'pages/FourOhFour';
import UrlSanitizer, { sanitizeSearch, sanitizeProperty } from 'components/UrlSanitizer';
import ErrorBoundary from 'components/errors/ErrorBoundary';
import buildDestinationRouteData from 'lib/destination/buildDestinationRouteData';

export const routeData = [
  { name: 'search-list', path: '/search/list', component: ListSearch, sanitizeQuery: sanitizeSearch },
  { name: 'search-map', path: '/search/map', component: MapSearch, sanitizeQuery: sanitizeSearch },
  { name: 'checkout', path: '/checkout', component: Checkout },
  { name: 'property', path: '/properties/:propertyId', component: Property, sanitizeQuery: sanitizeProperty },
  { name: 'booking-confirmation', path: '/bookings/:bookingId', component: BookingConfirmation },
  { name: 'contact-us-form', path: '/contact-us/email', component: Enquiry },
  { name: 'contact-us', path: '/contact-us', component: ContactUs },
  { name: 'faqs', path: '/faqs', component: FAQs },
  ...buildDestinationRouteData(Destination),
];

export const getRouteMatchForURL = (url) => {
  return routeData.reduce((matched, route) => {
    if (matched) return matched;
    const match = matchPath(url.replace(/\?.*$/, ''), route);
    return match ? { ...route, ...match } : null;
  }, null);
};

const Routes = React.memo(() => {
  return (
    <ErrorBoundary>
      <UrlSanitizer />
      <Switch>
        {routeData.map((route) => {
          const { component: Component, name, ...props } = route;
          return (
            <Route key={name} {...props}>
              <Component />
            </Route>
          );
        })}
        <Route>
          <FourOhFourPage />
        </Route>
      </Switch>
    </ErrorBoundary>
  );
});

Routes.displayName = 'Routes';

export default Routes;
